export const BATTLE_TIMINGS = {
  // Victory sequence phases
  VICTORY: {
    METER_OVERDRIVE_DURATION: 1200, // Increased for dramatic buildup
    ELIMINATION_WAIT: 1200,
    TRANSFER_DURATION: 1500,
    COINS_CLEANUP_DELAY: 1000,
    FLOATING_TEXT_DURATION: 2000,
    SCREEN_SHAKE_DURATION: 800,
  },

  // Betting intervals
  BETTING: {
    NORMAL_INTERVAL: 400,
    NORMAL_VARIANCE: 100,
    RALLY_INTERVAL: 200,
    RALLY_VARIANCE: 200,
    COUNTER_BET_MIN_DELAY: 1000,
    COUNTER_BET_MAX_DELAY: 4000,
  },

  // Order animations
  ORDERS: {
    DISPLAY_DURATION: 3000,
  },

  // Coin animations
  COINS: {
    PARTICLE_DELAY_BASE: 0.03,
    PARTICLE_DELAY_VARIANCE: 0.02,
    ANIMATION_DURATION_BASE: 1.2,
    ANIMATION_DURATION_LARGE_BONUS: 0.3,
    ROTATION_DURATION: 1.5,
  },

  // UI transitions
  TRANSITIONS: {
    METER_FLASH_DURATION: 0.5,
    SCREEN_SHAKE_X_DURATION: 0.4,
    SCREEN_SHAKE_Y_DURATION: 0.4,
  },
} as const;

export const BATTLE_VALUES = {
  // Betting amounts
  BETTING: {
    NORMAL_MIN: 10,
    NORMAL_MAX: 250,
    RALLY_MIN: 150,
    RALLY_MAX: 500,
    COUNTER_BET_MULTIPLIER_MIN: 1.1,
    COUNTER_BET_MULTIPLIER_MAX: 1.3,
    MAX_BET: 500,
  },

  // Betting probabilities
  PROBABILITIES: {
    WINNER_BIAS_NORMAL: 0.4,
    WINNER_BIAS_RALLY: 0.9,
  },

  // Coin particle configuration
  COINS: {
    TOTAL_PARTICLES: 30,
    POSITION_VARIANCE: 20,
    ARC_HEIGHT: 30,
    SIZES: ["small", "small", "small", "medium", "medium", "large"] as const,
    VALUES: [50, 100, 100, 250, 250, 500, 500, 1000, 1000],
  },

  // Initial meter positions
  METER: {
    LOSER_ADVANTAGE_A_WINS: 35, // When A wins, B (loser) starts at advantage
    LOSER_ADVANTAGE_B_WINS: 65, // When B wins, A (loser) starts at advantage
    VICTORY_POSITION_A: 97,
    VICTORY_POSITION_B: 0,
    DEFAULT_POSITION: 50,
  },
} as const;
